export const importDefaultOrderTypes = ["DINE_IN", "DELIVERY", "ROOM_SERVICE", "PICK_UP"];
export const importOrderDateMatchTypes = ["default", "earliest", "latest"];
export const ORDERS_DEFAULT_EXPORT_COLUMNS = "NUMBER,CREATED_AT,STATUS,EMPLOYEE,COMMENT,TOTAL_AMOUNT,PAYMENT_METHODS";

// t("enums.orders.date_match_types.default")
// t("enums.orders.date_match_types.earliest")
// t("enums.orders.date_match_types.latest")
